<template>
  <div ref="editor" style="border: 1px solid #ccc;"></div>
</template>

<script>
import E from 'wangeditor'

export default {
  props: {
    value: { type: String, default: '' },
    model: { type: String, default: '' },
    field: { type: String, default: '' }
  },
  data() {
    return {
      editor: null
    }
  },
  mounted() {
    this.initEditor()
  },
  beforeDestroy() {
    // 销毁编辑器，避免内存泄漏
    if (this.editor) {
      this.editor.destroy()
      this.editor = null
    }
  },
  watch: {
    // 监听外部传入的 value 变化
    value(newVal) {
      // 避免自己触发 onchange 造成死循环
      if (this.editor && newVal !== this.editor.txt.html()) {
        this.editor.txt.html(newVal || '')
      }
    }
  },
  methods: {
    initEditor() {
      const self = this
      self.editor = new E(self.$refs.editor)
      self.editor.config.pasteIgnoreImg = true
      self.editor.config.showLinkImg = false
      self.editor.config.excludeMenus = ['video']
      // 监听内容变化，通知父组件
      self.editor.config.onchange = (newHtml) => {
        this.$emit('input', { data: newHtml, field: self.field })
      }
      self.editor.create()
      self.editor.txt.html(self.value || '')
      self.editor.config.customUploadImg = function (resultFiles, inserImgFn) {
        let isFile = true
        resultFiles.forEach((file) => {
          if (file.size > 5 * 1024 * 1024) {
            ElMessage.warning({ showClose: true, message: '文件过大，只允许上传最大5M图片' })
            isFile = false
          }
        })
        if (isFile) {
          resultFiles.forEach((file) => {
            const formData = new FormData()
            formData.append('contractFile', file)
            formData.append('modelCode', self.model)
            formData.append('fieldCode', self.field)
            self.$axios.post('/account/oss/ossFile', formData).then((res) => {
              inserImgFn(res.data.data.url)
            }).catch(() => { })
          })
        }
      }
    }
  }
}
</script>